import util from '@bmp-vue/core/api/util'
import ui from '@bmp-vue/core/api/ui'
// import multiplo from './multiplo.js'
import errorservice from './errorservice.js'

const controller = 'Proposta'
export default Object.assign({}, util.GetCrud(controller, ['none']), {
  ImportarAssinantesCCB (codigoProposta, notificarPorEmail, callbackSuccess, callbackError) {
    // const dto = { parameters: [{ name: 'CodigoProposta', value: codigoProposta }, { name: 'NotificarPorEmail', value: notificarPorEmail }] }
    // multiplo.Post('ImportarAssinantesCCB', dto).then((response) => {
    //  if (ui.PostLoadData(response, true)) {
    //    if (typeof callbackSuccess === 'function') { callbackSuccess() }
    //  } else {
    //    if (typeof callbackError === 'function') { callbackError() }
    //  }
    // })
  },
  ValidarValorGravame (valorGravame) {
    if (!valorGravame || valorGravame === 0) {
      const msg = 'O valor do Gravame não foi carregado. Por gentileza, atualize a página e tente novamente.'
      ui.ShowError(msg)
      errorservice.RegisterError(msg)
      return false
    }
    return true
  },
  ValidaDocumentoEmitente (documentoEmitente, documentoAvalista) {
    if (documentoEmitente && documentoAvalista) {
      return [ui.Format.SomenteNumeros(documentoEmitente) !== ui.Format.SomenteNumeros(documentoAvalista) ||
          'O Documento informado é o mesmo do Emitente da Proposta']
    }
  },
  ValidaDocumentoConjuge (documentoConjuge, documentoAvalista) {
    if (documentoAvalista && documentoConjuge) {
      return [ui.Format.SomenteNumeros(documentoConjuge) !== ui.Format.SomenteNumeros(documentoAvalista) ||
          'O Documento informado é o mesmo do Avalista da Proposta']
    }
  },
  ValidaPJ (CNPJEmitente, CNPJSocio) {
    if (CNPJSocio) {
      return [CNPJEmitente !== CNPJSocio || 'O CNPJ do Sócio não pode ser igual o Emitente']
    }
  },
  ValidacaoConjuge (CPFEmitente, CPFConjuge) {
    if (CPFConjuge) {
      return [CPFEmitente !== CPFConjuge || 'O CPF do cônjuge não pode ser igual o emitente']
    }
  },
  ValidaDataFundacao (model, socio) {
    const data = model.PropostaAvalistaPJ[`Socio${socio}DtEntrada`]
    return [!model.PropostaAvalistaPJ.DtFundacao || !data || ui.Date.DaysBetween(ui.Parse.Date(model.PropostaAvalistaPJ.DtFundacao), ui.Parse.Date(data)) >= 0 || 'Data de entrada não pode ser anterior a data de fundação']
  },
})
